import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { DataService } from "src/app/core/services/data.service";
import { UploadService } from "src/app/core/services/upload.service";
import { HttpClient } from "@angular/common/http";
const ExifParser = require('exif-parser');

@Component({
  selector: "app-grid-gallery-item",
  templateUrl: "./grid-gallery-item.component.html",
  styleUrls: ["./grid-gallery-item.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class GridGalleryItemComponent implements AfterViewInit {

  @Input() image!: any;
  @Input() imageIndex!: any;
  @Input() rowHeight: number = 1;
  @Input() gutterSize: number = 1;
  @Input() totalImages!: any;
  @Input() isAnnonymous!: any;
  @ViewChild("img") img!: ElementRef;
  userId: any;
  labelId: any;
  public rows: number = 0;
  @Input()
  isDeleteEnabled: boolean = false;
  imageArrayBuffer: ArrayBuffer | null = null;
  orientation: any;

  get rotationAngle(): string | undefined {
    return this.image?.rotation;
  }

  constructor(private uploadService: UploadService, private dataService: DataService,
    private http: HttpClient
  ) {
  }


  // async imageUrlToBuffer(imageUrl: any): Promise<any> {
  //   try {
  //     const response = await axios.get(imageUrl, {
  //       responseType: 'arraybuffer'
  //     });
  //     return new Promise((resolve, reject) => {
  //       setTimeout(() => {
  //         resolve(response.data);
  //       }, 2000);
  //     });
  //   } catch (error) {
  //     console.error('Error fetching image:', error);
  //     throw error;
  //   }
  // }

  isUploadedFromIOS(fileBuffer: any) {
    try {
      const parser = ExifParser.create(fileBuffer).stream;
      // console.log(parser.global.navigator); //__CONSOLE_LOG__
      const result = parser.global.navigator;// parser.parse();
      // console.log(result.appVersion); //__CONSOLE_LOG__

      if (result.tags && result.tags.Make && result.tags.Model) {
        const make = result.tags.Make.toLowerCase();
        const model = result.tags.Model.toLowerCase();
        return make.includes('apple') && model.includes('iphone');
      }
    } catch (error) {
      // console.error('Error reading EXIF data:', error); //__CONSOLE_LOG__
    }
    return false;
  }



  @HostListener("window:resize")
  async calculateRows() {
    this.rows = Math.floor(
      this.img.nativeElement.offsetHeight / (this.rowHeight + this.gutterSize)
    );
  }

  ngAfterViewInit() {
    // console.log(this.img) //__CONSOLE_LOG__
  }

  ngOnInit() {
    this.labelId = 'cb' + this.image.id;
    this.userId = this.dataService.userId;
  }

  toggleSelection(item: any) {
    // console.log({ item }); //__CONSOLE_LOG__

    item.selected = !item.selected;
  }
}


